<template>
  <div class="main_filter">
    <!-- <p class="mt-3" style="font-size: 22px; font-weight: bolder">ตัวกรอง</p> -->
    <b-row class="my-4 mx-1 align-items-center">
      <b-col  lg="2" md="12"
        > <b-row class="justify-content-end mr-1" ><div  style=" font-size: 22px; font-weight: bolder">ตัวกรอง</div></b-row> 
      </b-col>
      <b-col lg="2" md="12">
        <b-row class="my-1">
          <multiselect
            v-if="options1"
            id="country"
            v-model="community"
            :close-on-select="true"
            :options="options1"
            label="name"
            track-by="community_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกชุมชน"
          ></multiselect>
        </b-row>
      </b-col>
      <b-col lg="2" md="12">
        <b-row class="my-1">
          <multiselect
            id="type"
            v-if="options2"
            v-model="category"
            :close-on-select="true"
            :options="options2"
            label="name"
            track-by="category_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกกลุ่มชนิดพืช"
          ></multiselect>
        </b-row>
      </b-col>
      <b-col lg="2" md="12">
        <b-row class="my-1">
          <multiselect
            id="wisdom"
            v-if="options3"
            v-model="knowledge"
            :close-on-select="true"
            :options="options3"
            label="name"
            track-by="knowledge_level1_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกภูมิปัญญา"
          ></multiselect>
        </b-row>
      </b-col>
      <b-col lg="2" md="12">
        <b-row class="my-1">
          <b-button
            class="btn btn-block"
            pill
            size="lg"
            style="background-color: #db7f50; margin-top: 0px !important"
            @click="getData"
          >
            <b-icon-filter></b-icon-filter> กรอง</b-button
          >
        </b-row>
      </b-col>
      <b-col lg="2" md="12">
        <b-row class="my-1">
          <b-button
            class="btn btn-block"
            pill
            size="lg"
            style="background-color: #948781; margin-top: 0px !important"
            @click="clearSearch"
          >
            ล้างค่า</b-button
          >
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "main_filter",
  data() {
    return {
      community: "",
      category: "",
      knowledge: "",
      options1: [],
      options2: [],
      options3: [],
      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelectediuhe",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
    };
  },
  components: {
    Multiselect,
  },
  async created() {
    await this.$store.dispatch("OptionsModule/onGetOption");
    this.options1 = this.communityoption;
    this.options2 = this.categoryoption;
    this.options3 = this.knowledgeoption;
    this.options1.unshift({name:'ทุกชุมชน', community_id:null})
    this.options2.unshift({name:'ทุกกลุ่มชนิดพืช', category_id:null})
    this.options3.unshift({name:'ทุกภูมิปัญญา', knowledge_level1_id:null})
  },
  computed: {
    ...mapState({
      communityoption: (state) => {
        return state.OptionsModule.community;
      },
      categoryoption: (state) => {
        return state.OptionsModule.categories;
      },
      knowledgeoption: (state) => {
        return state.OptionsModule.knowledge_level1s;
      },
    }),
  },
  methods: {
    getData() {
      let data = {
        community: this.community ? this.community.community_id : "",
        category: this.category ? this.category.category_id : "",
        knowledge: this.knowledge ? this.knowledge.knowledge_level1_id : "",
      };
      this.$store.dispatch("dashboardModule/searchFE", data).then((res) => {});
    },
    clearSearch() {
      this.community = "";
      this.category = "";
      this.knowledge = "";
      let data = {
        community: "",
        category: "",
        knowledge: "",
      };
      this.$store.dispatch("dashboardModule/searchFE", data).then((res) => {});
    },
  },
};
</script>
<style lang="scss">
.main_filter {
  min-height: 10vh;
}
</style>
